import { createApp } from 'vue';
import PictToJpgConverter from '../Components/PictToJpgConverter.vue';

createApp(PictToJpgConverter).mount('#pict-to-jpg-converter');
